import * as i0 from "@angular/core";
var pageGuideKey = 'PAGE_GUIDE_DISMISSED';
var PageGuideService = /** @class */ (function () {
    function PageGuideService() {
        this.internalPageGuideVerification = false;
    }
    PageGuideService.prototype.startPageGuide = function () {
        var _this = this;
        var pageGuideStarted = (localStorage.getItem('pageGuide') === 'true');
        if (!pageGuideStarted && !this.internalPageGuideVerification) {
            tl.pg.init({
                check_welcome_dismissed: function () {
                    if (_this.isPageGuideDismissed())
                        return true;
                    return false;
                },
                dismiss_welcome: function () {
                    localStorage.setItem(pageGuideKey, '1');
                },
                auto_refresh: true,
                handle_doc_switch: function (current, previous) {
                    var firstSelect = '.first_element_to_target';
                    if (current == firstSelect) {
                        var firstElement = document.querySelector(firstSelect);
                        firstElement.click();
                    }
                },
                pg_caption: "Tour Guiado"
            });
            this.internalPageGuideVerification = true;
            localStorage.setItem('pageGuide', 'true');
        }
    };
    PageGuideService.prototype.shutdownPageGuide = function () {
        tl.pg.destroy();
        this.internalPageGuideVerification = false;
        localStorage.setItem('pageGuide', 'false');
    };
    PageGuideService.prototype.isPageGuideDismissed = function () {
        return localStorage.getItem(pageGuideKey);
    };
    PageGuideService.prototype.getInternalPageGuideVerification = function () {
        return this.internalPageGuideVerification;
    };
    Object.defineProperty(PageGuideService.prototype, "isPageGuideActive", {
        get: function () {
            var pageGuide = document.querySelector('div.tlypageguide_toggle.tlyPageGuideToggleActive');
            if (!pageGuide)
                return false;
            return true;
        },
        enumerable: true,
        configurable: true
    });
    PageGuideService.ngInjectableDef = i0.defineInjectable({ factory: function PageGuideService_Factory() { return new PageGuideService(); }, token: PageGuideService, providedIn: "root" });
    return PageGuideService;
}());
export { PageGuideService };
